export function Brand() { return <div className="brand"><img className="brand-mark" src="/logo-ecletica.jpeg" alt="" width="72" height="52" /><span>Eclética<small>TECNOLOGIA</small></span></div>; }
